type Listener = () => void;

let isForbidden = false;

const listeners = new Set<Listener>();

export const forbiddenStore = {
  getSnapshot: (): boolean => isForbidden,

  subscribe: (listener: Listener) => {
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  },

  setForbidden: (value: boolean) => {
    if (isForbidden === value) {
      return;
    }

    isForbidden = value;

    listeners.forEach((listener) => {
      listener();
    });
  },
};